'use client';

import { useEffect, useState } from 'react';

export function usePageVisibility() {
	// Always start `true` so the client's first render matches the
	// server-rendered markup. Reading `document.hidden` in the initializer would
	// make hidden-tab hydration differ from the server (isVisible=true) and
	// trigger a hydration mismatch. The real value is synced in the effect below.
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		const handleVisibilityChange = () => {
			setIsVisible(!document.hidden);
		};

		// Sync the actual visibility once mounted (document is client-only).
		setIsVisible(!document.hidden);
		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, []);

	return isVisible;
}
